<template>
    <div class="overflow-x-auto sm:overflow-x-visible ">
        <div v-if="opciones" class="p-5 flex flex-col-reverse sm:flex-row text-gray-600 border-b border-gray-200 dark:border-dark-1">
            <div class="flex items-center mt-3 sm:mt-0 border-t sm:border-0 border-gray-200 pt-5 sm:pt-0 mt-5 sm:mt-0 -mx-5 sm:mx-0 px-5 sm:px-0">
                <input @change="select(2)" ref="check" class="input border border-gray-500" type="checkbox" />
                <div class="dropdown ml-1" data-placement="bottom-start">
                    <a class="dropdown-toggle w-5 h-5 block dark:text-gray-300" href="javascript:;">
                        <ChevronDownIcon class="w-5 h-5" />
                    </a>
                    <div class="dropdown-box w-64">
                        <div class="dropdown-box__content box p-2">
                            <button @click="select(1)" class="flex items-center block p-2 transition duration-300 ease-in-out bg-white dark:bg-dark-1 hover:bg-gray-200 dark:hover:bg-dark-2 rounded-md">Todos</button>
                            <button @click="select(0)" class="flex items-center block p-2 transition duration-300 ease-in-out bg-white dark:bg-dark-1 hover:bg-gray-200 dark:hover:bg-dark-2 rounded-md">Ninguno</button>
                            <button @click="mark(1)" class="flex items-center block p-2 transition duration-300 ease-in-out bg-white dark:bg-dark-1 hover:bg-gray-200 dark:hover:bg-dark-2 rounded-md">Marcar como leído</button>
                            <button @click="mark(0)" class="flex items-center block p-2 transition duration-300 ease-in-out bg-white dark:bg-dark-1 hover:bg-gray-200 dark:hover:bg-dark-2 rounded-md">Marcar como no leído</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-for="(notificacion, index) in filteredNotificaciones" :key="index" class="intro-y">
            <div class="inbox__item inline-block sm:block text-gray-700 dark:text-gray-500 bg-white dark:bg-dark-1 border-b border-gray-200 dark:border-dark-1" :class="{ 'inbox__item--active': !notificacion.leido }">
                <div class="flex justify-between px-5 select-none">
                    <div class="w-56 flex-none flex items-start mr-10 py-3 flex-shrink-0">
                        <input class="input flex-none border border-gray-500" type="checkbox" v-model="notificacion.seleccionado" />
                        <div class="inbox__item--sender truncate ml-3" @click="desplegate(notificacion)">
                            {{ notificacion.from }}
                        </div>
                    </div>
                    <div class="w-full py-3" @click="desplegate(notificacion)">
                        <p>{{ notificacion.asunto }}</p>
                        <p class="text-gray-600 text-xs my-4 text-normal" v-if="estaDesplegado(notificacion)" v-html="notificacion.texto"></p>
                    </div>
                    <div class="inbox__item--time whitespace-no-wrap ml-auto pl-10 py-3 flex-shrink-0">
                        {{ notificacion.createdDate }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style>
.inbox .inbox__item.inbox__item--active .inbox__item--sender,
.inbox .inbox__item.inbox__item--active .w-full p:not(.text-normal) {
    font-weight: bolder !important;
}
</style>
<script>
import Vue from "vue";

export default {
    props: ["searchTerm", "limit", "order", "opciones"],
    components: {},
    data() {
        return {
            data: [],
            desplegado: []
        };
    },
    computed: {
        filteredNotificaciones() {
            var data = this.data;
            if (this.searchTerm) data = this.data.filter(rec => rec.asunto && rec.asunto.toLowerCase().indexOf(this.searchTerm.toLowerCase()) > -1);
            if (this.limit) data = data.slice(0, this.limit);
            return data;
        }
    },
    mounted() {
        this.init();
    },
    watch: {
        '$route': function(from, to) {
            this.init();
        }
    },
    methods: {
        init() {
            this.data = this.$d().user.notificaciones.map((rec) => {
                Vue.set(rec, "seleccionado", false);
                Vue.set(rec, "leido", rec.leido == 0 ? false : true);
                // rec.seleccionado = false
                // rec.leido = rec.leido == 0 ? false : true
                return rec
            });
        },
        estaDesplegado(noti) {
            return this.desplegado.indexOf(noti.num) !== -1;
        },
        desplegate(noti) {
            let desplegado = this.desplegado.indexOf(noti.num);
            if (desplegado !== -1) {
                this.desplegado = this.desplegado.filter((each) => each != noti.num);
            } else {
                this.desplegado.push(noti.num);
            }
            Vue.set(noti, "leido", true);
            this.updateData(noti);
        },
        select(type) {
            if (type == 2) {
                var checked = this.$refs.check.checked;
                this.data.map(rec => rec.seleccionado = checked);
                return;
            }
            this.data.map(rec => rec.seleccionado = type ? true : false);
        },
        mark(type) {
            for (let noti of this.data) {
                if (noti.seleccionado) {
                    noti.leido = type ? true : false;
                    this.updateData({ num: noti.num, leido: noti.leido ? 1 : 0 });
                }
            }
        },
        updateData(noti) {
            CmsApi.hook("/hooks/save/", { data: JSON.stringify(noti), action: 'notificacion', token: this.$cookie.get("token") });
        }
    }
};
</script>